import { Geolocation } from '@capacitor/geolocation';

/** Capacitor rejects clearWatch when the ID was already cleared or never registered. */
export function isWatchIdNotFoundError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  return /watchid not found/i.test(message);
}

/**
 * Clears a Geolocation watch without surfacing stale-ID rejections to Sentry.
 * Other clearWatch failures still propagate.
 */
export async function safeClearGeolocationWatch(id: string): Promise<void> {
  try {
    await Geolocation.clearWatch({ id });
  } catch (error) {
    if (isWatchIdNotFoundError(error)) return;
    throw error;
  }
}
